// extracted by mini-css-extract-plugin
module.exports = {"container":"RnkimContent_container__3W1y-","frame":"RnkimContent_frame__2WnJu","spin":"RnkimContent_spin__3ze9J"};